import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import Button from "components/components/Button/Button";
import FullWidthSection from "components/components/FullWidthSection/FullWidthSection";
import HeaderNav from "components/components/HeaderNav/HeaderNav";
import PageMeta from "components/components/Meta/PageMeta";
import AuthenticatedView from "components/components/Remit/AuthenticatedView/AuthenticatedView";
import UsefulLinks from "components/components/Remit/UsefulLinks/UsefulLinks";
import { PageTitle } from "components/components/Remit/commonStyle";
import { GreyContainer, Header } from "components/shared/UsefulLinks/style";
import { useErrorContext } from "contexts/ErrorContext";
import React from "react";
import { loginRequest } from "utils/authUtils";

const SCHEMA_LINK =
  "https://github.com/elexon-data/REMIT-Submissions-API-Developer-Guide/blob/main/schemas/remit2_1.xsd";

const RemitSubmit: React.FC = () => {
  const { instance } = useMsal();
  const { registerError } = useErrorContext();

  const handleLogin = async (): Promise<void> => {
    try {
      await instance.loginRedirect({
        redirectUri: "/remit/submit",
        ...loginRequest,
      });
    } catch (e) {
      registerError();
    }
  };

  return (
    <>
      <PageMeta title="Submit REMIT" />
      <HeaderNav title="Submit REMIT" />
      <FullWidthSection>
        <PageTitle>Submit REMIT</PageTitle>
        <p>
          This page allows market participants to submit REMIT (Regulation on
          wholesale Energy Markets Integrity and Transparency) notifications
          directly through Insights.
        </p>
        <p>
          Submissions are validated against the{" "}
          <a
            href={SCHEMA_LINK}
            target="_blank"
            rel="noreferrer"
            data-test-id="remit-schema-link"
            className="is-link"
          >
            Elexon schema for REMIT notification
          </a>
          . Please note that submissions are rate limited.
        </p>
        <AuthenticatedTemplate>
          <AuthenticatedView />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <div data-test-id="remit-unauthenticated-message">
            <p>You need to be logged in to submit REMIT notifications.</p>
            <br />
            <Button
              buttonText="Log in to Insights"
              onClick={handleLogin}
              className="mb-6"
            />
          </div>
        </UnauthenticatedTemplate>
        <GreyContainer className="container px-6">
          <Header>Useful links</Header>
          <UsefulLinks />
        </GreyContainer>
      </FullWidthSection>
    </>
  );
};

export default RemitSubmit;
